<template>
  <div class="box">
    <div class="columns">
      <div class="column">
        <p class="title has-text-black is-5 has-text-weight-semibold">Contacts</p>
      </div>
      <div class="column">
        <!--router-link  v-bind:to="'/fiche-client'" class="is-pulled-right">
          <b-icon icon="plus-circle" type="is-primary" size=""></b-icon> Ajouter un contact
        </router-link-->
      </div>
    </div>
    <br>
    <v-client-table v-if="client && client.contacts.length"
                    ref="tableListe"
                    :data="client.contacts"
                    :columns="columns"
                    :options="options">
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';

const Client = createNamespacedHelpers('client');

export default {
  name: 'contact',
  data() {
    return {
      trad: {
        civilite: '↑↓ Civilité',
        nom: '↑↓ Nom',
        prenom: '↑↓ Prénom',
        fonction: '↑↓ Fonction',
        fixe: '↑↓ Téléphone fixe',
        portable: '↑↓ Portable',
        email: '↑↓ Email',
        adrLibelle1: '↑↓ Adresse',
      },
    };
  },
  computed: {
    ...Client.mapGetters([
      'client',
    ]),
    columns() {
      return ['civilite', 'nom', 'prenom', 'fonction', 'telephone', 'portable', 'email', 'adrLibelle1'];
    },
    options() {
      return {
        headings: {
          civilite: this.trad.civilite,
          nom: this.trad.nom,
          prenom: this.trad.prenom,
          fonction: this.trad.fonction,
          telephone: this.trad.fixe,
          portable: this.trad.portable,
          email: this.trad.email,
          adrLibelle1: this.trad.adrLibelle1,
        },
        filterable: false,
        perPageValues: PER_PAGE_VALUE,
        perPage: 10,
        texts: TEXTS,
      };
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/clientProspect/ficheClient/information/contact.vue